import React from "react";
import { Menu, Icon, Button, Layout, Alert } from "antd";
import { Link } from "react-router-dom";
import { withNamespaces } from "react-i18next";

import classes from "./PageLayout.css";
import { withRouter } from "react-router";
import { withParams } from "../../utils/url";
import {
  getProjectConfigurationStatus,
  getUserToken,
  getUserInfoRoles,
  getSystemMessage, getAPIVersion, getHostName,
} from "../../reducers/user/selectors";
import { getDimensionWidth } from "../../reducers/dimensions/selectors";
import { getTheme } from "../../reducers/theme/selectors";
import { connect } from "react-redux";
import classNames from "classnames";
import get from "lodash/get";
import AdminHeader from "../../components/AdminHeader/AdminHeader";
import Sidebar from "./Sidebar";
import Footer from "../../components/Footer/Footer";
const routes = require("../../routes.json");

class PageLayout extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      collapsed: window.localStorage.getItem("menuCollapsed"),
      openMobileMenu: false,
    };
  }

  toggleCollapsed = () => {
    window.localStorage.setItem(
      "menuCollapsed",
      this.state.collapsed ? "" : "true"
    );
    this.setState({
      collapsed: !this.state.collapsed,
    });
  };

  defaultSelectedKeys = () => {
    return [
      this.props.location.pathname === routes.admin.dashboard
        ? "dashboard"
        : "",
      this.props.location.pathname === routes.admin.reporting
        ? "reporting"
        : "",
    ];
  };

  render() {
    const { dimensionWidth } = this.props;

    let feVersion = '';
    let apiVersion = get(this.props, 'apiVersion');
    try {
      feVersion = process.env.REACT_APP_APP_VERSION || '';
    } catch (error) {
      feVersion = "error";
    }

    return (
      <div>
        <Layout className={classes.parentContainer}>
          {this.props.token && <AdminHeader />}
          <div className={classes.wrapper}>
            {this.props.token && !this.props.userInfoRoles.includes("Patient") && (
              <div className={classes.openMenuWrapper}>
                <Button
                  block
                  className={classes.openMenu}
                  onClick={() => {
                    this.setState(({ openMobileMenu }) => ({
                      openMobileMenu: !openMobileMenu,
                    }));
                  }}
                >
                  Toggle Menu
                </Button>
              </div>
            )}

            {this.props.token && !this.props.userInfoRoles.includes("Patient") && (
              <div
                style={{
                  width: this.state.collapsed ? 80 : 200,
                  display: !this.state.openMobileMenu && dimensionWidth <= 767 ? "none" : "block",
                }}
                className={classes.sidebar}
              >
                <Button
                  type="primary"
                  onClick={this.toggleCollapsed}
                  style={{ margin: "0 0 10px 16px" }}
                  className={classes.toggleButton}
                >
                  <Icon
                    type={this.state.collapsed ? "menu-unfold" : "menu-fold"}
                  />
                </Button>

                <Sidebar collapsed={this.state.collapsed && dimensionWidth > 767} />
              </div>
            )}
            <div
              className={classNames(classes.content, {
                [classes.collapsed]: this.state.collapsed,
                [classes.full]:
                  !this.props.token ||
                  this.props.userInfoRoles.includes("Patient"),
              })}
            >
              {this.props.systemMessage && (
                // <Alert message={<div
                //     dangerouslySetInnerHTML={{
                //       __html: this.props.systemMessage
                //     }}
                //   />} type="warning" />

                <Alert
                  message={<h4>{this.props.systemMessage}</h4>}
                  type="warning"
                />
              )}
              {/*<h2 className={classes.headline}>{this.props.title}</h2>*/}
              {this.props.children}

              {this.props.token && this.props.isProjectConfigurationActive && (
                <Footer noAdminLink isAuthenticated={!!this.props.token} apiVersion={apiVersion} feVersion={feVersion} />
              )}
            </div>
          </div>
        </Layout>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  token: getUserToken(state),
  isProjectConfigurationActive: getProjectConfigurationStatus(state),
  apiVersion: getAPIVersion(state),
  systemMessage: getSystemMessage(state),
  userInfoRoles: getUserInfoRoles(state),
  dimensionWidth: getDimensionWidth(state),
});

export default connect(mapStateToProps)(
  withRouter(withNamespaces()(PageLayout))
);



// WEBPACK FOOTER //
// ./src/containers/PageLayout/PageLayout.js